import { jsx as _jsx } from "react/jsx-runtime";
import React, { useContext, useEffect, useState } from 'react';
import useStyles from '../GuidedNavigation/PCC.styles';
import Modal from '../Modal/Modal';
import PccModal from '../PCCModal/PCCModal';
import qs from 'qs';
import { useRouter } from 'next/router';
import { useMediaQuery } from 'react-responsive';
import format from 'date-fns/format';
import isSameDay from 'date-fns/isSameDay';
import clsx from 'clsx';
import { useTheme } from '@mui/material';
import { SiteContext } from '../../utils/common';
const submitFormInitialValues = {
    date: null,
    address: '',
    occasion: '',
    city: '',
    county: '',
    postalCode: '',
    country: '',
    isManualAddress: false,
    shouldValidatePostCode: true,
    addressLine2: '',
    addressLine1: '',
};
const PCCModalWrapper = (props) => {
    const { isOpen, setOpen, countriesList, showInternationalLink, setShowInternationalLink, trackPostCodeCheckerDate, trackPostCodeCheckerAddress, trackPostCodeCheckerManualAddress, trackPostCodeCheckerOccasion, submitPostCodeCheckerComplete, trackEnterManualAddressClick, locationInternationalDelivery, occasionQuickLinks, pccEditFeatureTracking, trackPCCCloseAnalytics, showRecommendedFacetsInPCC, hideOccasion, skipRedirect, onAvailabilityCheckerSubmit, initialStep, initialInfo, } = props;
    const theme = useTheme();
    const router = useRouter();
    const { shorthand } = useContext(SiteContext);
    const [isShowDatePicker, setIsShowDatePicker] = useState(false);
    const { classes } = useStyles({ isShowDatePicker, showInternationalLink });
    const [showAllOccasions, setShowAllOccasions] = React.useState(false);
    const [info, setInfo] = useState(submitFormInitialValues);
    const [showStepTitle, setShowStepTitle] = useState('When do you want your gift?');
    const [currentStep, setCurrentStep] = useState(1);
    const [isManualAddressChoosen, setIsManualAddressChoosen] = useState(false);
    const isLargerViewport = useMediaQuery({ query: `(min-width: ${theme.breakpoints.values.md}px)` });
    useEffect(() => {
        if (isOpen) {
            setInfo(initialInfo ? Object.assign(Object.assign({}, submitFormInitialValues), initialInfo) : submitFormInitialValues);
            setCurrentStep(initialStep !== null && initialStep !== void 0 ? initialStep : 1);
            setIsShowDatePicker(false);
            setIsManualAddressChoosen(false);
            setShowAllOccasions(false);
        }
        // intentionally omitted: read once at open time, not on every prop change
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isOpen]);
    const submitForm = (values) => {
        sessionStorage.setItem('guidedNavigationValues', JSON.stringify(values));
        const { date, postalCode, city, county, occasion, addressLine2 } = values;
        submitPostCodeCheckerComplete === null || submitPostCodeCheckerComplete === void 0 ? void 0 : submitPostCodeCheckerComplete();
        if (skipRedirect) {
            // IFCT-8794: Update context before closing — avoids iOS Safari suppressing
            // state updates queued after setOpen(false).
            onAvailabilityCheckerSubmit === null || onAvailabilityCheckerSubmit === void 0 ? void 0 : onAvailabilityCheckerSubmit(values);
            setOpen(false);
            setInfo(submitFormInitialValues);
            return;
        }
        setOpen(false);
        // Reset form data when submitted
        setInfo(submitFormInitialValues);
        const qsObj = Object.assign({ date: date ? format(date, 'yyyy-MM-dd') : undefined, postalCode,
            city,
            county,
            addressLine2,
            occasion, isSameDay: !!date && isSameDay(date, new Date()) }, (shorthand === 'uk' && {
            showRecommendedFacetsInPCC,
        }));
        router.push(`/search?${qs.stringify(qsObj, { encodeValuesOnly: true })}`);
    };
    const handleClose = () => {
        setShowInternationalLink && setShowInternationalLink(false);
        setOpen(false);
        setIsShowDatePicker(false);
        setShowAllOccasions(false);
        setIsManualAddressChoosen(false);
        setCurrentStep(1);
        let event;
        if (currentStep === 1) {
            event = isShowDatePicker ? 'load_more_dates' : 'date_picker';
        }
        else if (currentStep === 2) {
            if (showInternationalLink) {
                event = 'international_delivery_link';
            }
            else if (isManualAddressChoosen) {
                event = 'manual_address_choosen';
            }
            else {
                event = 'delivery_address';
            }
        }
        else if (currentStep === 3) {
            event = showAllOccasions ? 'more_occasions' : 'occasions';
        }
        if (event) {
            trackPCCCloseAnalytics === null || trackPCCCloseAnalytics === void 0 ? void 0 : trackPCCCloseAnalytics(event);
        }
    };
    const modalTitle = (_jsx("span", { className: clsx(classes.modalTitle, showInternationalLink ? classes.customizeTitle : ''), children: _jsx("span", { children: showStepTitle }) }));
    return isOpen ? (_jsx(Modal, { open: isOpen, className: clsx(classes.modal, showInternationalLink ? classes.internationalModal : ''), maxWidth: "md", fullScreen: !isLargerViewport, setOpen: setOpen, noPadding: !isLargerViewport, title: showInternationalLink && modalTitle, isFromPccOccasion: !!(showStepTitle === null || showStepTitle === void 0 ? void 0 : showStepTitle.includes('occasion')), isMobileDatePicker: isShowDatePicker, onClose: handleClose, children: _jsx(PccModal, { info: info, setInfo: setInfo, submitForm: submitForm, onCancel: setOpen, isOpen: isOpen, setStepTitle: setShowStepTitle, setIsShowDatePicker: setIsShowDatePicker, isShowDayPicker: isShowDatePicker, setShowInternationalLink: setShowInternationalLink, showInternationalLink: showInternationalLink, countriesList: countriesList, trackPostCodeCheckerDate: trackPostCodeCheckerDate, trackPostCodeCheckerAddress: trackPostCodeCheckerAddress, trackPostCodeCheckerManualAddress: trackPostCodeCheckerManualAddress, trackPostCodeCheckerOccasion: trackPostCodeCheckerOccasion, trackEnterManualAddressClick: trackEnterManualAddressClick, locationInternationalDelivery: locationInternationalDelivery, occasionQuickLinks: occasionQuickLinks, showAllOccasions: showAllOccasions, setShowAllOccasions: setShowAllOccasions, pccEditFeatureTracking: pccEditFeatureTracking, path: router.asPath, setCurrentStep: (step) => setCurrentStep(step !== null && step !== void 0 ? step : 1), currentStep: currentStep, setIsManualAddressChoosen: setIsManualAddressChoosen, hideOccasion: hideOccasion }) })) : null;
};
export default PCCModalWrapper;
